/* ImageDropZonePreview.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _17 = "._bfhk10xm{background-color:var(--ds-blanket,#091e427d)}";
const _16 = "._4t3i1osq{height:100%}";
const _15 = "._1ltvidpf{left:0}";
const _14 = "._154iidpf{top:0}";
const _13 = "._1pbycs5v{z-index:2}";
const _12 = "._80omtlke{cursor:pointer}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._1bah1h6o{justify-content:center}";
const _9 = "._4cvr1h6o{align-items:center}";
const _8 = "._kqswh2mm{position:relative}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._1lrw1dfr{background-size:cover}";
const _5 = "._2rkopb1k{border-radius:var(--ds-radius-xlarge,9pt)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import Spinner from '@atlaskit/spinner';
import { useState } from 'react';
import { IMAGE_FIELD_DROP_ZONE_CHANGE_IMAGE, IMAGE_FIELD_DROP_ZONE_CROSS_ICON, IMAGE_FIELD_DROP_ZONE_PREVIEW, IMAGE_FIELD_DROP_ZONE_SPINNER } from './testIds';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "._1pbykb7n{z-index:1}";
const _3 = "._1xi21b66{right:var(--ds-space-050,4px)}";
const _2 = "._154i1b66{top:var(--ds-space-050,4px)}";
const _ = "._kqswstnw{position:absolute}";
const CrossIcon = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswstnw _154i1b66 _1xi21b66 _1pbykb7n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CrossIcon.displayName = 'CrossIcon';
}
const Preview = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkopb1k _1lrw1dfr _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1h6o _1bsb1osq _80omtlke", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Preview.displayName = 'Preview';
}
const PreviewContent = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kqswh2mm _1pbycs5v", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PreviewContent.displayName = 'PreviewContent';
}
const Overlay = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _, _14, _15, _11, _16, _17, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkopb1k _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _bfhk10xm _1pbykb7n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Overlay.displayName = 'Overlay';
}
const ImageDropZonePreview = props => {
  const {
    imageUploading,
    url,
    handleFileDelete,
    enableDeleteImage,
    isDisabled
  } = props;
  const [isPreviewHovered, setIsPreviewHovered] = useState(false);
  const deleteImage = e => {
    e.stopPropagation();
    handleFileDelete();
  };
  return /*#__PURE__*/_jsx(Preview, {
    style: {
      backgroundImage: url !== null && url !== void 0 && url.imageUrl ? "url(".concat(url === null || url === void 0 ? void 0 : url.imageUrl, ")") : undefined,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    onMouseEnter: () => setIsPreviewHovered(true),
    onMouseLeave: () => setIsPreviewHovered(false),
    "data-testid": IMAGE_FIELD_DROP_ZONE_PREVIEW,
    children: (isPreviewHovered || imageUploading) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Overlay, {}), /*#__PURE__*/_jsxs(PreviewContent, {
        children: [imageUploading && /*#__PURE__*/_jsx(Spinner, {
          testId: IMAGE_FIELD_DROP_ZONE_SPINNER,
          interactionName: "load",
          label: "Loading",
          size: "large"
        }), !imageUploading && /*#__PURE__*/_jsx(Button, {
          appearance: "primary",
          testId: IMAGE_FIELD_DROP_ZONE_CHANGE_IMAGE,
          isDisabled: isDisabled,
          children: "Change image"
        })]
      }), enableDeleteImage && /*#__PURE__*/_jsx(CrossIcon, {
        onClick: deleteImage,
        children: /*#__PURE__*/_jsx(CrossCircleIcon, {
          label: "delete-image",
          testId: IMAGE_FIELD_DROP_ZONE_CROSS_ICON,
          color: "var(--ds-icon-inverse)"
        })
      })]
    })
  });
};
export default ImageDropZonePreview;